import { omit, uniq } from "lodash"
import { useEffect } from "react"

type Params = {
  filter: string
  [key: string]: string | undefined
}

export default function useFilters(
  key: string,
  ids: string[],
  updateParams: (updater: (prev: Params) => Params) => void,
) {
  useEffect(() => {
    updateParams((prev) => updateFilterParams(prev, key, ids))
  }, [key, ids, updateParams])
}

function updateFilterParams(prev: Params, key: string, ids: string[]) {
  const filterParts = prev.filter?.split(",") ?? []

  if (ids.length > 0) {
    const filter = uniq([...filterParts, key]).join(",")
    return { ...prev, filter, [`${key}_id`]: ids.join(",") }
  } else {
    const filter = filterParts.filter((value) => value !== key).join(",")
    return omit({ ...prev, filter }, `${key}_id`)
  }
}
